<template>
  <div class="ref-control">
    <el-form :model="control" label-width="70px">
      <el-form-item prop="name">
        <template slot="label">
          <span class="require-flag">*</span>
          名称
        </template>
        <el-input v-model="control.name"></el-input>
      </el-form-item>
      <el-form-item prop="refSheetId">
        <template slot="label">
          <span class="require-flag">*</span>
          关联表
        </template>
        <div class="refSheetContainer">
          <tree-select
            ref="sheetSelector"
            style="width: 100%; background-color: unset"
            v-model="control.refSheetId"
            :disabled="!control['_isNew']"
            :group-list="availableSheetList"
            @change="selectAvailableSheet"
          ></tree-select>
          <el-tooltip content="设置保存后将不能再修改" placement="bottom">
            <div class="icon-tip">
              <i class="el-icon-info"></i>
            </div>
          </el-tooltip>
          <el-tooltip content="点击编辑关联表" placement="bottom">
            <div class="icon-tip">
              <i class="el-icon-link" @click.stop="editRefSheet"></i>
            </div>
          </el-tooltip>
        </div>
      </el-form-item>
      <el-form-item prop="oneFlag">
        <template slot="label">
          <span class="require-flag">*</span>
          数量
        </template>
        <div class="ref-one-flag-row">
          <el-radio-group v-model="control.oneFlag" @change="checkChange">
            <el-radio :label="true">一条</el-radio>
            <el-radio :label="false">多条</el-radio>
          </el-radio-group>
        </div>
      </el-form-item>
      <el-form-item prop="treeKey" v-if="showTreeKey">
        <template slot="label">
          显示样式
        </template>
        <div>
          <el-select :value="control.treeKey ? 'tree' : 'list'" @input="treeKeyInput">
            <el-option label="列表" value="list"></el-option>
            <el-option label="树状" value="tree"></el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item prop="fields">
        <template slot="label">
          <span class="require-flag">*</span>
          显示字段
        </template>
        <el-select
          v-model="control.fields"
          multiple
          filterable
          clearable
          placeholder="请选择"
          style="width: 100%"
          @change="changeSelect($event, 'fields')"
        >
          <div style="padding: 5px 20px 8px 20px;border-bottom: 1px solid #eaeaea;">
            <el-checkbox
              :value="control.fields && control.fields.length === this.currentFields.length"
              @input="selectAll($event, 'fields')"
            >
              全选
            </el-checkbox>
          </div>
          <el-option
            v-for="item in currentFields"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="searchFields" v-if="control.oneFlag">
        <template slot="label">
          搜索字段
        </template>
        <el-select
          v-model="control.searchFields"
          multiple
          filterable
          clearable
          placeholder="请选择"
          style="width: 100%"
          @change="changeSelect($event, 'searchFields')"
        >
          <div style="padding: 5px 20px 8px 20px;border-bottom: 1px solid #eaeaea;">
            <el-checkbox
              :value="
                control.searchFields &&
                  control.searchFields.length === this.currentSearchFields.length
              "
              @input="selectAll($event, 'searchFields')"
            >
              全选
            </el-checkbox>
          </div>
          <el-option
            v-for="item in currentSearchFields"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="defaultVal.id" v-if="control.oneFlag">
        <template slot="label">
          默认值
        </template>
        <tree-select
          style="background-color: unset"
          v-model="control.defaultVal.id"
          :group-list="defaultVars"
        ></tree-select>
      </el-form-item>
      <el-form-item prop="description">
        <template slot="label">
          描述
        </template>
        <el-input v-model="control.description"></el-input>
      </el-form-item>
      <el-form-item prop="sorts" v-if="!_.isEmpty(control.fields)">
        <template slot="label">
          排序
        </template>
        <el-button v-if="_.isEmpty(control.sorts)" type="text" @click="settingSorts">
          设置排序
        </el-button>
        <sort-list
          v-else
          :sheet-list="showFields"
          :sorts="control.sorts"
          from="refControl"
        ></sort-list>
      </el-form-item>
      <el-form-item prop="filters">
        <template slot="label">
          关联筛选
        </template>
        <el-button type="text" @click="sheetFilterVisible = true">设置筛选条件</el-button>
      </el-form-item>
      <el-form-item prop="twoWay">
        <template slot="label">
          双向关联
        </template>
        <div class="refSheetContainer">
          <el-checkbox :disabled="!control['_isNew']" v-model="control.twoWay"></el-checkbox>
          <el-tooltip content="设置保存后将不能再修改" placement="bottom">
            <div class="icon-tip">
              <i class="el-icon-info"></i>
            </div>
          </el-tooltip>
        </div>
        <span
          v-if="control.twoWay && !control['_isNew']"
          style="background-color: #ebebeb; padding-left: 10px;"
          v-tip
        >
          反向关联字段 : [关联] {{ refSheet.name }}.{{ refFields }}
        </span>
      </el-form-item>
      <el-form-item prop="related">
        <template slot="label">
          主从关联
        </template>
        <el-checkbox v-model="control.related" :disabled="control.oneFlag"></el-checkbox>
      </el-form-item>
      <el-form-item prop="required">
        <template slot="label">
          必填
        </template>
        <el-checkbox v-model="control.required"></el-checkbox>
      </el-form-item>
      <el-form-item prop="display">
        <template slot="label">
          显示
        </template>
        <el-checkbox v-model="control.display"></el-checkbox>
      </el-form-item>
      <el-form-item prop="disabled">
        <template slot="label">
          不可编辑
        </template>
        <el-checkbox v-model="control.disabled"></el-checkbox>
      </el-form-item>
    </el-form>
    <sheet-filter
      @submit="setRefCondition"
      :dialog-visible.sync="sheetFilterVisible"
      :search-sheet="refSheet"
      :rely-sheet-info="sheet"
      :condition-list="control['filters']"
      from="sheet_backend"
    ></sheet-filter>
  </div>
</template>

<script>
import { decorateSheet, getSheetInAvailableSheets } from "@/utils/sheet"
import SheetFilter from "@/components/UIComponents/SheetFilter"
import TreeSelect from "@/components/UIComponents/TreeSelect"
import SortList from "@/components/UIComponents/SortList"

export default {
  name: "ref-control",
  components: {
    SortList,
    SheetFilter,
    TreeSelect
  },
  props: {
    control: Object,
    sheet: Object,
    fields: Array,
    availableSheets: Array
  },
  data() {
    return {
      availableSheetVisible: false,
      sheetFilterVisible: false
    }
  },
  computed: {
    // 可以关联的工作表
    availableSheetList() {
      return this.availableSheets.map((app, index) => {
        return {
          id: app.id,
          label: index === 0 ? app.name + " [当前应用]" : app.name + " [共享应用]",
          options: app.sheets.map(sheet => {
            return {
              label: `[${app.name}] ${sheet.name}`,
              value: sheet.sheetId
            }
          })
        }
      })
    },
    // [关联表]当前关联字段可选搜索字段
    currentSearchFields() {
      let sheet = getSheetInAvailableSheets(this.availableSheets, this.control.refSheetId)
      if (Object.keys(sheet).length == 0) return []
      if (this.control.oneFlag) {
        return []
          .concat(decorateSheet(sheet).controls)
          .filter(
            c =>
              (!["remark", "chart"].includes(c._type) && c._dataType === "string") ||
              ["option", "area", "company"].includes(c._type)
          )
          .map(c => ({ label: c.name, value: c._cid }))
      } else {
        return []
          .concat(decorateSheet(sheet).controls)
          .filter(c => !["remark", "chart"].includes(c._type))
          .map(c => ({ label: c.name, value: c._cid }))
      }
    },
    curOriginFields() {
      let sheet = getSheetInAvailableSheets(this.availableSheets, this.control.refSheetId)
      if (Object.keys(sheet).length == 0) return []
      return []
        .concat(decorateSheet(sheet).controls)
        .filter(c => !["remark", "chart"].includes(c._type))
    },
    // [关联表]当前关联字段可选显示字段
    currentFields() {
      return this.curOriginFields.map(c => ({ label: c.name, value: c._cid }))
    },
    refAppId() {
      return this.refSheet.appId || ""
    },
    refSheet() {
      if (!this.control.refSheetId) return {}
      for (let app of this.availableSheets) {
        let sheet = app.sheets.find(i => i.sheetId === this.control.refSheetId)
        if (sheet) return sheet
      }
      return {}
    },
    refFields() {
      if (this._.isEmpty(this.refSheet)) return ""
      let refControl = this.refSheet.controls.find(control => control._cid === this.control._ccid)
      return refControl ? refControl.name : ""
    },
    defaultVars() {
      let result = []
      let controls = this.sheet.controls.filter(
        c =>
          c._type === "ref" &&
          c._cid !== this.control._cid &&
          c.oneFlag &&
          c.refSheetId === this.control.refSheetId
      )
      if (!this._.isEmpty(controls)) {
        result.push({
          label: "自己",
          options: controls.map(c => ({ label: "[自己] " + c.name, value: c._cid }))
        })
      }
      this.sheet.controls
        .filter(c => c._type === "ref" && c.refSheetId !== this.control.refSheetId)
        .forEach(c => {
          let sheet = decorateSheet(getSheetInAvailableSheets(this.availableSheets, c.refSheetId))
          if (sheet) {
            let refControls = sheet.controls?.filter(
              rc => rc._type === "ref" && rc.oneFlag && rc.refSheetId === this.control.refSheetId
            )
            if (!this._.isEmpty(refControls)) {
              result.push({
                label: c.name,
                options: refControls.map(rc => ({
                  label: "[" + c.name + "] " + rc.name,
                  value: c._cid + "_" + rc._cid
                }))
              })
            }
          }
        })
      return result
    },
    showTreeKey() {
      return !this.control.oneFlag && this.control.refSheetId === this.sheet.sheetId
    },
    showFields() {
      return this.curOriginFields.filter(field => this.control.fields?.includes(field._cid))
    }
  },
  mounted() {
    // sheetId如果不存在则可以修改(模板导入)
    if (!this.$refs.sheetSelector.valueLabelMap[this.control.refSheetId]) {
      this.$set(this.control, "_isNew", true)
    }
  },
  methods: {
    // 选择关联的工作表
    selectAvailableSheet() {
      this.control.fields = null
      this.control.searchFields = null
      this.control.oneFlag = true
      this.$emit("change")
      this.refSheetOrViewChange()
    },
    // “关联表” 中所选的关联表或关联视图发生变化时，将与该 关联表 相关联的 关联表字段 信息重置
    refSheetOrViewChange() {
      this.clearRefFieldInfo()
    },
    // 重置 关联表字段 的 refCid 和 field
    clearRefFieldInfo() {
      let flag = false
      this.fields.forEach(i => {
        if (i._type === "field" && i.refCid === this.control._cid) {
          i.refCid = i.field = ""
          flag = true
        }
      })
      flag &&
        this.$message({
          message: "与该 关联表 相关联的 关联表字段 信息已重置",
          duration: 5000,
          showClose: true
        })
    },
    // [关联表]展开关联表选择列表
    expandAvailableSheet() {
      if (!this.control._isNew) return
      this.availableSheetVisible = !this.availableSheetVisible
    },
    setRefCondition(condition) {
      this.control.filters = condition
    },
    checkChange(oneFlag) {
      if (!oneFlag) {
        this.control.defaultVal = {}
      } else {
        this.control.related = false
      }
    },
    editRefSheet() {
      const { href } = this.$router.resolve({
        name: "edit-sheet-field",
        query: { sheetId: this.control.refSheetId }
      })
      window.open(href, "_blank")
    },
    selectAll(selected, from) {
      this.control[from] = selected
        ? (from === "fields" ? this.currentFields : this.currentSearchFields).map(
            item => item.value
          )
        : []
    },
    changeSelect(val, from) {
      this.control[from] = val
      this.control.sorts = []
    },
    treeKeyInput(val) {
      this.$set(this.control, "treeKey", val == "tree" ? this.control._cid : null)
    },
    settingSorts() {
      this.control.sorts.push({ key: this.control.fields[0], direction: "DESC" })
    }
  }
}
</script>

<style lang="scss" scoped>
.ref-control {
  .el-form {
    padding: 12px 12px 0 0;
  }
  .refSheetContainer {
    display: flex;
    .icon-tip {
      margin-left: 6px;
      line-height: 40px;
      font-size: 20px;
      color: #bdbdbd;
      min-width: 30px;
      text-align: center;
      cursor: pointer;
    }
  }
}
</style>
